export class PaymentFormModel {
  public email: string = '';
  public card: string = '';
  public expiry: string = '';
  public cvc: string = '';
  public total: string = '';
  public permissionToAllowPayments: boolean = false;

  constructor (email?: string) {
    this.email = email;
  }
}

export class PaymentModel {
  private numberRegExp = /\d?\*?/;
  public currentBookingOptions: any = null; // current data of widget
  public user: any = null;
  public cardToken: any = null;
  public masks: any = {
    cvc: [this.numberRegExp, this.numberRegExp, this.numberRegExp],
    card: [
      this.numberRegExp, this.numberRegExp, this.numberRegExp, this.numberRegExp, ' ',
      this.numberRegExp, this.numberRegExp, this.numberRegExp, this.numberRegExp, ' ',
      this.numberRegExp, this.numberRegExp, this.numberRegExp, this.numberRegExp, ' ',
      this.numberRegExp, this.numberRegExp, this.numberRegExp, this.numberRegExp]
  };
  public cardDetection: string = '';
  public permissionForPayments: boolean = false;
  public changeDetectorRefTimeout: any = null;
  public disabledAfterPaymentForBlockingDoubleClick: boolean = false;

  constructor(
    currentBookingOptions: any,
    user: any,
    token: string
  ) {
    this.currentBookingOptions = currentBookingOptions;
    this.user = user;
    this.cardToken = token;
  }
}

export class PaymentStoreModel {
  public info$: any = null;
  public subscribtion: any = {
    booking$: null,
    info$: null
  };
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/payment/payment.model.ts